import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import * as moment from 'moment';
import {Option} from '@models/select-dropdown-option.interface';
import {CreateConsignmentService} from '@modules/consignment/create-consignment.service';
import {PackageDetailsService} from '@services/package-details.service';
import {AppState, selectUser} from '@store/reducers';
import {takeUntil} from 'rxjs/operators';
import {User} from '@models/user.interface';
import {Subject} from 'rxjs/Subject';
import {Store} from '@ngrx/store';
import 'rxjs/add/operator/map';

@Component({
  selector: 'shipping-detail-form',
  templateUrl: './shipping-detail-form.component.html',
  styleUrls: ['./shipping-detail-form.component.scss']
})

export class ShippingDetailFormComponent implements OnInit, OnDestroy {
  @Input() parent: FormGroup;
  @Input() submitted: boolean;
  @Input() shippingDetails: {parcel_value: string, parcel_content: string, pickup_date: string, pickup_time: string, daily_pickup: boolean};

  private unsubscribe: Subject<void> = new Subject();
  userDetails: any = {};

  public dailyPickupChecked = false;
  public dailyPickupActiveForUser = false;
  public dailyPickupDefaultTime = '';

  timeOptions: Array<Option> = [
    '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00',
    '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'
  ].map(t => ({value: t, label: t}));

  constructor(
    private packagesDetailsService: PackageDetailsService,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.store.select(selectUser)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: User) => {
        this.userDetails = data;

        let parcelContent = data.settings.parcel_content;
        let parcelValue = data.settings.parcel_value;

        if (this.shippingDetails && this.shippingDetails.parcel_content) {
          parcelContent = this.shippingDetails.parcel_content;
        }

        if (this.shippingDetails && this.shippingDetails.parcel_value) {
          parcelValue = this.shippingDetails.parcel_value;
        }

        this.parent.addControl('parcel_value',
          new FormControl(parcelValue, [Validators.required])
        );
        this.parent.addControl('parcel_content',
          new FormControl(parcelContent, [Validators.required])
        );
        if (data) {
          // console.log(this.parent.get('parcel_content').setValue('123'));
          // this.parent.get('parcel_content').setValue(data.settings.parcel_content);
          // this.parent.get('parcel_value').setValue(data.settings.parcel_value);
          this.dailyPickupActiveForUser = Boolean(parseInt(this.userDetails.settings.daily_pickup_active, 10)); // convert to boolean
          this.dailyPickupDefaultTime = this.userDetails.settings.daily_pickup_default_time;
        }
      });

    this.parent.addControl('daily_pickup',
      new FormControl(false)
    );

    if (this.dailyPickupActiveForUser && this.shippingDetails) {
      // Set from saved
      this.parent.get('daily_pickup').setValue(this.shippingDetails.daily_pickup);
      this.dailyPickupChecked = this.shippingDetails.daily_pickup;
    } else if (this.dailyPickupActiveForUser && this.userDetails.settings.daily_pickup) {
      // Set from user settings
      this.parent.get('daily_pickup').setValue(true);
      this.dailyPickupChecked = true;
    } else {
      this.dailyPickupChecked = false;
      this.parent.get('daily_pickup').disable();
    }

    const validDateTime = ShippingDetailFormComponent.validDateTime;
    this.parent.addControl('pickupDateTime', new FormGroup({
      date: new FormControl(
        (this.shippingDetails && this.shippingDetails.pickup_date) || validDateTime.date,
        [Validators.required]
      ),
      time: new FormControl(
        (this.shippingDetails && this.shippingDetails.pickup_time) || validDateTime.time,
        [Validators.required]
      ),
    }, ShippingDetailFormComponent.futureDateTimeValidator));

    this.toggleDateFileds(this.dailyPickupChecked);
  }

  dailyPickupChange(checked) {
    this.toggleDateFileds(checked);
  }

  toggleDateFileds(disable) {
    if (disable) {
      this.parent.get('pickupDateTime').disable();
      this.parent.get('pickupDateTime.date').setValue(moment().format('YYYY-MM-DD'));
      this.parent.get('pickupDateTime.time').setValue(this.dailyPickupDefaultTime);
    } else {
      const dateTime = ShippingDetailFormComponent.validDateTime;
      this.parent.get('pickupDateTime.time').setValue(this.shippingDetails && this.shippingDetails.pickup_time || dateTime.time);
      this.parent.get('pickupDateTime').enable();
    }
  }

  static get validDateTime() {
    //"2018-05-31"
    let date: any = new Date();
    let time = moment().add(1, 'hours').subtract(moment().minutes(), 'minutes').format('HH:mm');
    const hours = moment().add(1, 'hours').hours();
    if (hours < 8 || hours > 20) {
      date = new Date(Date.now() + 1000 * 60 * 60 * 24);
      time = '08:00';
    }
    date = date.getTime();
    date = moment(date).format('YYYY-MM-DD');
    return {date, time};
  }

  get fieldsValidationStatus() {
    return true;
  }

  get shipmentSummaryData() {
    const packages = this.parent.getRawValue().packages;
    return {
      ...this.packagesDetailsService.getTotalPackagesData(packages, true),
      from: this.parent.get('from').value,
      to: this.parent.get('to').value,
    }
  }

  static futureDateTimeValidator(group: FormGroup) {
    const date = moment(`${group.get('date').value} ${group.get('time').value}`, "YYYY-MM-DD HH:mm");

    return date.diff(moment()) > 0 ? null : {pastDate: true};
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/search/components/shipping-detail-form/shipping-detail-form.component.ts